import axios from "axios";
import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import BookClassModal from "./Modals/BookClassModal";
import LoginOrSignUpModal from "./Modals/LoginOrSignUpModal";
import {
  ChevronBarLeft,
  ChevronLeft,
  ChevronRight,
} from "react-bootstrap-icons";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function TimeTable({ id }) {
  const [events, setEvents] = useState([]);

  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  const [mondayDate, setMondayDate] = useState("");
  const [tuesdayDate, setTuesdayDate] = useState("");
  const [wednesdayDate, setWednesdayDate] = useState("");
  const [thursdayDate, setThursdayDate] = useState("");
  const [fridayDate, setFridayDate] = useState("");
  const [saturdayDate, setSaturdayDate] = useState("");
  const [sundayDate, setSundayDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [mondayDateNoFormat, setMondayDateNoFormat] = useState("");
  const [tuesdayDateNoFormat, setTuesdayDateNoFormat] = useState("");
  const [wednesdayDateNoFormat, setWednesdayDateNoFormat] = useState("");
  const [thursdayDateNoFormat, setThursdayDateNoFormat] = useState("");
  const [fridayDateNoFormat, setFridayDateNoFormat] = useState("");
  const [saturdayDateNoFormat, setSaturdayDateNoFormat] = useState("");
  const [sundayDateNoFormat, setSundayDateNoFormat] = useState("");

  const [monday, setMonday] = useState([]);
  const today = new Date();

  const [tuesday, setTuesday] = useState([]);
  const [wednesday, setWednesday] = useState([]);
  const [thursday, setThursday] = useState([]);
  const [friday, setFriday] = useState([]);
  const [saturday, setSaturday] = useState([]);
  const [sunday, setSunday] = useState([]);
  const { user } = useAuthContext();
  const [bookings, setBookings] = useState([]);
  const [bookClassModal, setBookClassModal] = useState(false);

  const [selectedBooking, setSelectedBooking] = useState([]);
  const [loginModal, setLoginModal] = useState(false);

  const [products, setProducts] = useState([]);
  const [showPastDays, setShowPastDays] = useState(false);
  const [pastAndPresentExist, setPastAndPresentExist] = useState(false);

  useEffect(() => {
    const currentDate = new Date();
    let pastExists = false;
    let presentExists = false;

    events.forEach((event) => {
      const eventDate = new Date(event.oneOffDate);
      if (eventDate < currentDate) {
        pastExists = true;
      }
      if (eventDate >= currentDate) {
        presentExists = true;
      }
    });

    if (pastExists && presentExists) {
      setPastAndPresentExist(true);
    } else {
      setPastAndPresentExist(false);
    }
  }, [events]);
  const cancelModal = () => {
    setBookClassModal(false);
    setLoginModal(false);
  };

  const getDateTime = () => {
    const now = currentDateTime;
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const addOneWeek = () => {
    setCurrentDateTime((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + 7);
      return newDate;
    });
  };

  const minusOneWeek = () => {
    if (pastAndPresentExist && !showPastDays) {
      setShowPastDays(true);
    } else {
      setShowPastDays(true);
      setCurrentDateTime((prevDate) => {
        const newDate = new Date(prevDate);
        newDate.setDate(newDate.getDate() - 7);
        return newDate;
      });
    }
  };

  useEffect(() => {
    // Filter and sort events based on the day and timeIn
    if (events) {
      setMonday(
        events
          .filter((event) => event.day === "Monday")
          .sort((a, b) => a.timeIn - b.timeIn)
      );
      setTuesday(
        events
          .filter((event) => event.day === "Tuesday")
          .sort((a, b) => a.timeIn - b.timeIn)
      );
      setWednesday(
        events
          .filter((event) => event.day === "Wednesday")
          .sort((a, b) => a.timeIn - b.timeIn)
      );
      setThursday(
        events
          .filter((event) => event.day === "Thursday")
          .sort((a, b) => a.timeIn - b.timeIn)
      );
      setFriday(
        events
          .filter((event) => event.day === "Friday")
          .sort((a, b) => a.timeIn - b.timeIn)
      );
      setSaturday(
        events
          .filter((event) => event.day === "Saturday")
          .sort((a, b) => a.timeIn - b.timeIn)
      );
      setSunday(
        events
          .filter((event) => event.day === "Sunday")
          .sort((a, b) => a.timeIn - b.timeIn)
      );
    }
  }, [events, id, user]);

  const futureEvents = events.filter((event) => {
    const now = new Date();
    const eventDate = new Date(event.oneOffDate);
    eventDate.setHours(Math.floor(event.timeIn / 100), event.timeIn % 100);
    return eventDate > now;
  });

  const printDay = (index) => {
    switch (index) {
      case 0:
        return "Monday";
      case 1:
        return "Tuesday";
      case 2:
        return "Wednesday";
      case 3:
        return "Thursday";
      case 4:
        return "Friday";
      case 5:
        return "Saturday";
      case 6:
        return "Sunday";
    }
  };

  const fetchData = async () => {
    setIsLoading(true);

    try {
      if (user) {
        const [bookingResponse, eventResponse] = await Promise.all([
          axios.get(
            `${ApiConnectionString}/api/Bookings?&ClubId=${id}&FromDateTime=${getDateTime()}&weekly=true`,
            {
              headers: { Authorization: `Bearer ${user.token}` },
            }
          ),
          axios.get(
            `${ApiConnectionString}/api/events?ClubId=${id}&FromDateTime=${getDateTime()}`,
            {
              headers: { Authorization: `Bearer ${user.token}` },
            }
          ),
        ]);

        const bookings = bookingResponse.data;
        const events = eventResponse.data;

        const updatedEvents = events.map((event) => ({
          ...event,
          booked: bookings.some(
            (booking) =>
              booking.eventId === event.id && booking.date === event.oneOffDate
          ),
        }));

        setBookings(bookings);
        setEvents(updatedEvents);

        const productsResponse = await axios.get(
          `${ApiConnectionString}/api/products?ClubId=${id}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );
        setProducts(productsResponse.data);
      } else {
        // View events offline
        const eventResponse = await axios.get(
          `${ApiConnectionString}/api/events?ClubId=${id}&FromDateTime=${getDateTime()}`
        );
        setEvents(eventResponse.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getWeekDates = (currentDate) => {
      const monday = new Date(currentDate);
      const day = monday.getDay();
      const diffToMonday = (day === 0 ? -6 : 1) - day;
      monday.setDate(monday.getDate() + diffToMonday);

      return Array.from({ length: 7 }, (_, i) => {
        const date = new Date(monday);
        date.setDate(monday.getDate() + i);
        date.setHours(23, 59, 0, 0); // Set time to 23:59
        return date;
      });
    };

    fetchData();

    const [mon, tue, wed, thu, fri, sat, sun] = getWeekDates(
      new Date(currentDateTime)
    );

    setMondayDate(mon.toLocaleDateString());
    setTuesdayDate(tue.toLocaleDateString());
    setWednesdayDate(wed.toLocaleDateString());
    setThursdayDate(thu.toLocaleDateString());
    setFridayDate(fri.toLocaleDateString());
    setSaturdayDate(sat.toLocaleDateString());
    setSundayDate(sun.toLocaleDateString());

    setMondayDateNoFormat(mon);
    setTuesdayDateNoFormat(tue);
    setWednesdayDateNoFormat(wed);
    setThursdayDateNoFormat(thu);
    setFridayDateNoFormat(fri);
    setSaturdayDateNoFormat(sat);
    setSundayDateNoFormat(sun);
  }, [currentDateTime, id, user]);

  function formatTime(time) {
    const hours = Math.floor(time / 100);
    const minutes = time % 100;
    const suffix = hours >= 12 ? "pm" : "am";
    const displayHours = hours % 12 || 12;
    return `${displayHours}${
      minutes ? `.${String(minutes).padStart(2, "0")}` : ""
    }${suffix}`.replace(".", ":");
  }

  if (!isLoading) {
    return (
      <div className="mb-2 pb-2">
        <div className="customNav row mx-2">
          <div className="col mt-2">
            <p className="fw-bold fontSize20">Classes</p>
          </div>
          <div className="col mt-3">
            <p>
              {mondayDate} - {sundayDate}
            </p>
          </div>
          <div className="col d-flex justify-content-end mt-3">
            <div
              className="d-flex mx-3 cursor-pointer"
              onClick={() => minusOneWeek()}
            >
              <ChevronLeft className="mt-1" />
              <p>Previous</p>
            </div>
            <div className="d-flex cursor-pointer" onClick={() => addOneWeek()}>
              <p>Next</p>
              <ChevronRight className="mt-1" />
            </div>
          </div>
        </div>

        {(events.length === 0 ||
          (futureEvents.length === 0 && !showPastDays)) && (
          <div className="text-center">
            <p className="fw-bold">No more classes this week.</p>
            <button
              className="btn btn-outline-secondary"
              onClick={() => minusOneWeek()}
            >
              View Previous Classes
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => addOneWeek()}
            >
              View Next Week's Classes
            </button>
          </div>
        )}

        {/* {events.length == 0 && (
          <div className="text-center">
            <p className="fw-bold">No more classes this week.</p>
            <button
              className="btn btn-outline-secondary"
              onClick={() => minusOneWeek()}
            >
              View Previous Classes
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => addOneWeek()}
            >
              View Next Week's Classes
            </button>
          </div>
        )}
        {futureEvents.length === 0 && !showPastDays && (
          <div className="text-center">
            <p className="fw-bold">No more classes this week.</p>
            <button
              className="btn btn-outline-secondary"
              onClick={() => minusOneWeek()}
            >
              View Previous Classes
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => addOneWeek()}
            >
              View Next Week's Classes
            </button>
          </div>
        )} */}
        <div
          className={`row timetable mx-5 ${
            monday.length == 0 &&
            tuesday.length == 0 &&
            thursday.length == 0 &&
            friday.length == 0 &&
            saturday.length == 0 &&
            sunday.length == 0
              ? "d-none"
              : ""
          }`}
        >
          <div
            className={`col p-0 ${monday.length == 0 ? "d-none" : ""} ${
              mondayDateNoFormat < today && showPastDays && "opacity-50"
            } ${mondayDateNoFormat < today && !showPastDays && "d-none"}`}
          >
            <div>
              <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
                <p className="px-5"> Monday</p>
                <p className="mb-0">{mondayDate}</p>
              </div>

              {monday.map((activity) => (
                <div
                  className="classes-container maxWidthTimetable"
                  key={activity.id}
                >
                  <div className="class-content text-center">
                    <p className="fontSize20">{activity.name}</p>

                    <p className="fontSize14 fw-bold">
                      {`${formatTime(activity.timeIn)} - ${formatTime(
                        activity.timeOut
                      )}`}
                    </p>
                    {activity.bookingCapacity - activity.bookedCount > 0 && (
                      <p>
                        Spaces left:{" "}
                        {activity.bookingCapacity - activity.bookedCount}
                      </p>
                    )}

                    {!activity.booked ? (
                      <p
                        className="book-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book now"}
                      </p>
                    ) : (
                      <p
                        className="booked-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book more"}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className={` col p-0 ${tuesday.length == 0 ? "d-none" : ""} ${
              tuesday.length == 0 &&
              thursday.length == 0 &&
              friday.length == 0 &&
              saturday.length == 0 &&
              sunday.length == 0
                ? "d-none"
                : ""
            } ${tuesdayDateNoFormat < today && showPastDays && "opacity-50"} ${
              tuesdayDateNoFormat < today && !showPastDays && "d-none"
            }`}
          >
            <div className="">
              <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
                <p className="px-5"> Tuesday</p>
                <p className="mb-0">{tuesdayDate}</p>
              </div>

              {tuesday.map((activity) => (
                <div
                  className="classes-container maxWidthTimetable"
                  key={activity.id}
                >
                  <div className="class-content text-center">
                    <p className="fontSize20">{activity.name}</p>
                    {/* <p className="fontSize12">{activity.description}</p> */}
                    <p className="fontSize14 fw-bold">
                      {`${formatTime(activity.timeIn)} - ${formatTime(
                        activity.timeOut
                      )}`}
                    </p>
                    {activity.bookingCapacity - activity.bookedCount > 0 && (
                      <p>
                        Spaces left:{" "}
                        {activity.bookingCapacity - activity.bookedCount}
                      </p>
                    )}
                    {!activity.booked ? (
                      <p
                        className="book-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book now"}
                      </p>
                    ) : (
                      <p
                        className="booked-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book more"}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className={`col p-0 ${wednesday.length == 0 ? "d-none" : ""} ${
              wednesday.length == 0 &&
              thursday.length == 0 &&
              friday.length == 0 &&
              saturday.length == 0 &&
              sunday.length == 0
                ? "d-none"
                : ""
            } ${
              wednesdayDateNoFormat < today && showPastDays && "opacity-50"
            } ${wednesdayDateNoFormat < today && !showPastDays && "d-none"}`}
          >
            <div>
              <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
                <p className="px-5">Wednesday</p>
                <p className="mb-0">{wednesdayDate}</p>
              </div>

              {wednesday.map((activity) => (
                <div
                  className="classes-container maxWidthTimetable"
                  key={activity.id}
                >
                  <div className="class-content text-center">
                    <p className="fontSize20">{activity.name}</p>
                    {/* <p className="fontSize12">{activity.description}</p> */}
                    <p className="fontSize14 fw-bold">
                      {`${formatTime(activity.timeIn)} - ${formatTime(
                        activity.timeOut
                      )}`}
                    </p>
                    {activity.bookingCapacity - activity.bookedCount > 0 && (
                      <p>
                        Spaces left:{" "}
                        {activity.bookingCapacity - activity.bookedCount}
                      </p>
                    )}
                    {!activity.booked ? (
                      <p
                        className="book-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book now"}
                      </p>
                    ) : (
                      <p
                        className="booked-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book more"}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className={`col p-0 ${thursday.length == 0 ? "d-none" : ""} ${
              thursday.length == 0 &&
              friday.length == 0 &&
              saturday.length == 0 &&
              sunday.length == 0
                ? "d-none"
                : ""
            } ${thursdayDateNoFormat < today && showPastDays && "opacity-50"} ${
              thursdayDateNoFormat < today && !showPastDays && "d-none"
            }`}
          >
            <div>
              <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
                <p className="px-5">Thursday</p>
                <p className="mb-0">{thursdayDate}</p>
              </div>

              {thursday.map((activity) => (
                <div
                  className="classes-container maxWidthTimetable"
                  key={activity.id}
                >
                  <div className="class-content text-center">
                    <p className="fontSize20">{activity.name}</p>
                    {/* <p className="fontSize12">{activity.description}</p> */}
                    <p className="fontSize14 fw-bold">
                      {`${formatTime(activity.timeIn)} - ${formatTime(
                        activity.timeOut
                      )}`}
                    </p>
                    {activity.bookingCapacity - activity.bookedCount > 0 && (
                      <p>
                        Spaces left:{" "}
                        {activity.bookingCapacity - activity.bookedCount}
                      </p>
                    )}
                    {!activity.booked ? (
                      <p
                        className="book-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book now"}
                      </p>
                    ) : (
                      <p
                        className="booked-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book more"}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className={`col p-0 ${friday.length == 0 ? "" : ""} ${
              friday.length == 0 && saturday.length == 0 && sunday.length == 0
                ? "d-none"
                : ""
            } ${fridayDateNoFormat < today && showPastDays && "opacity-50"} ${
              fridayDateNoFormat < today && !showPastDays && "d-none"
            }`}
          >
            <div>
              <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
                <p className="px-5">Friday</p>
                <p className="mb-0">{fridayDate}</p>
              </div>

              {friday.map((activity) => (
                <div
                  className="classes-container maxWidthTimetable"
                  key={activity.id}
                >
                  <div className="class-content text-center">
                    <p className="fontSize20">{activity.name}</p>
                    {/* <p className="fontSize12">{activity.description}</p> */}
                    <p className="fontSize14 fw-bold">
                      {`${formatTime(activity.timeIn)} - ${formatTime(
                        activity.timeOut
                      )}`}
                    </p>
                    {activity.bookingCapacity - activity.bookedCount > 0 && (
                      <p>
                        Spaces left:{" "}
                        {activity.bookingCapacity - activity.bookedCount}
                      </p>
                    )}
                    {!activity.booked ? (
                      <p
                        className="book-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book now"}
                      </p>
                    ) : (
                      <p
                        className="booked-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book more"}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className={`col p-0 ${saturday.length == 0 ? "d-none" : ""} ${
              saturday.length == 0 && sunday.length == 0 ? "d-none" : ""
            } ${saturdayDateNoFormat < today && showPastDays && "opacity-50"} ${
              saturdayDateNoFormat < today && !showPastDays && "d-none"
            }`}
          >
            <div>
              <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
                <p className="px-5">Saturday</p>
                <p className="mb-0">{saturdayDate}</p>
              </div>

              {saturday.map((activity) => (
                <div
                  className="classes-container maxWidthTimetable"
                  key={activity.id}
                >
                  <div className="class-content text-center ">
                    <p className="fontSize20">{activity.name}</p>
                    {/* <p className="fontSize12">{activity.description}</p> */}
                    <p className="fontSize14 fw-bold">
                      {`${formatTime(activity.timeIn)} - ${formatTime(
                        activity.timeOut
                      )}`}
                    </p>
                    {activity.bookingCapacity - activity.bookedCount > 0 && (
                      <p>
                        Spaces left:{" "}
                        {activity.bookingCapacity - activity.bookedCount}
                      </p>
                    )}
                    {!activity.booked ? (
                      <p
                        className="book-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book now"}
                      </p>
                    ) : (
                      <p
                        className="booked-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book more"}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className={`col p-0 ${sunday.length == 0 ? "d-none" : ""} ${
              sunday.length == 0 ? "d-none" : ""
            } ${sundayDateNoFormat < today ? "opacity-50" : ""}`}
          >
            <div>
              <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
                <p className="px-5">Sunday</p>
                <p className="mb-0">{sundayDate}</p>
              </div>

              {sunday.map((activity) => (
                <div
                  className="classes-container maxWidthTimetable"
                  key={activity.id}
                >
                  <div className="class-content text-center">
                    <p className="fontSize20">{activity.name}</p>
                    {/* <p className="fontSize12">{activity.description}</p> */}
                    <p className="fontSize14 fw-bold">
                      {`${formatTime(activity.timeIn)} - ${formatTime(
                        activity.timeOut
                      )}`}
                    </p>
                    {activity.bookingCapacity - activity.bookedCount > 0 && (
                      <p>
                        Spaces left:{" "}
                        {activity.bookingCapacity - activity.bookedCount}
                      </p>
                    )}
                    {!activity.booked ? (
                      <p
                        className="book-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book now"}
                      </p>
                    ) : (
                      <p
                        className="booked-button mx-2 mt-2 mb-4"
                        onClick={() => {
                          if (user) {
                            const booking = {
                              price: activity.price,
                              eventId: activity.id,
                              date: activity.oneOffDate,
                              name: activity.name,
                              description: activity.description,
                              timeIn: activity.timeIn,
                              timeOut: activity.timeOut,
                              clubId: id,
                              stripeProductId: activity.stripeProductId,
                              fullyBooked:
                                activity.bookingCapacity ===
                                activity.bookedCount,
                            };
                            setSelectedBooking(booking);
                            setBookClassModal(true);
                          } else {
                            setLoginModal(true);
                          }
                        }}
                      >
                        {activity.bookingCapacity == activity.bookedCount
                          ? "Fully booked"
                          : "Book more"}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {bookClassModal && (
          <BookClassModal
            cancelModal={cancelModal}
            selectedBooking={selectedBooking}
            products={products}
            refresh={fetchData}
          />
        )}
        {loginModal && <LoginOrSignUpModal cancelModal={cancelModal} />}
      </div>
    );
  } else {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }
}
